import { Fragment, createContext, useState } from "react";
import GlobalStyle from "./styles/global";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";
import TopLinks from "./components/TopLinks";
import BottomTabs from "./components/Tabs";
import ClaimLife from "./components/ClaimLife";
import About from "./components/About";
import LargeLoadingAnimation from "./components/LargeScreenLoader";
import SmallLoadingAnimation from "./components/SmallScreenLoader";
import MapPage from "./components/NodeGrid";
import ReadPage from "./pages/ReadPage";
import BookCallPage from "./pages/BookCallPage";

const PageWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.4 }}
      style={{ position: "absolute", width: "100%", height: "100%" }}
    >
      {children}
    </motion.div>
  );
};

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <Fragment>
      <GlobalStyle />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <PageWrapper>
                <MapPage />
              </PageWrapper>
            }
          />
          <Route
            path="/read"
            element={
              <PageWrapper>
                <ReadPage />
              </PageWrapper>
            }
          />
          <Route
            path="/book-a-call"
            element={
              <PageWrapper>
                <BookCallPage />
              </PageWrapper>
            }
          />
        </Routes>
      </AnimatePresence>
    </Fragment>
  );
};

export const AppContext = createContext<any>(null);

const App = () => {
  const [claim, setClaim] = useState<boolean>(false);
  const [about, setAbout] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [load, setLoad] = useState<boolean>(true);

  setTimeout(() => {
    setLoading((prev) => !prev);
  }, 2000);

  return load ? (
    <Fragment>
      <LargeLoadingAnimation
        loading={loading}
        onComplete={() => setLoad(!load)}
      />
      <SmallLoadingAnimation
        loading={loading}
        onComplete={() => setLoad(!load)}
      />
    </Fragment>
  ) : (
    <AppContext value={{ setClaim, setAbout }}>
      <CssWrapper $showModal={claim || about}>
        <Router>
          <TopLinks />
          <AnimatedRoutes />
          <BottomTabs />
        </Router>
      </CssWrapper>
      <ClaimLife open={claim} />
      <About open={about} />
    </AppContext>
  );
};

export default App;

const CssWrapper = styled.div<{ $showModal: boolean }>`
  display: ${({ $showModal }) => ($showModal ? "none" : "block")};
`;
